var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1040,
    height: 988,
    viewBox: "0 0 1040 988",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.456 206.078L630.544 117.563L894.743 398.142L783.855 767.234L408.767 855.749L144.568 575.17L255.456 206.078Z",
    stroke: "#FFE713",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.009 190.873L650.488 121.699L901.134 417.482L770.302 782.439L388.823 851.614L138.177 555.831L269.009 190.873Z",
    stroke: "#FFBD13",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.387 233.348L591.893 105.158L886.161 358.466L813.924 739.964L447.419 868.154L153.15 614.846L225.387 233.348Z",
    stroke: "#FF7F38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235.255 224.016L604.908 109.038L889.309 371.678L804.056 749.296L434.403 864.274L150.002 601.634L235.255 224.016Z",
    stroke: "url(#paint0_linear_86_296)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_296",
    x1: 189.894,
    y1: 423.531,
    x2: 835.298,
    y2: 605.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8139"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2);
export default __webpack_public_path__ + "static/media/circle-2.dcf55b5592f9a4f5706cf0e26abf948c.svg";
export { ForwardRef as ReactComponent };